<template>
  <div>

<div class="danger tw-mx-5" v-if="alert">
  <span class="mx-3">
    ⚠️ แจ้งเตือนสำคัญ: หนังสือรับรอง (Certificate) ของท่านใกล้หมดอายุ
<br>
    <u class="ml-2">
      <b>
        โปรดต่ออายุและดาวน์โหลดไฟล์ XML ภายในวันที่ {{ expireDate }} โดยทันที
        มิฉะนั้นอาจส่งผลกระทบต่อการยื่นข้อมูลกับกรมสรรพากร
      </b>
    </u>
    <br>
  </span>
  <v-icon color="#fff" class="mx-2" @click="alert = false">
    mdi-close-circle-outline
  </v-icon>
</div>

    <div></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "AlertCertExpire",
  components: {},
  computed: mapState({
    listKey: (state) => state.keyByCompany.listKey,
    selectedCompany: (state) => state.companies.selectedCompany,
  }),
  created() {
    this.query();
  },
  data: () => ({
    items: [
      {
        text: "ตั้งค่า",
        disabled: false,
        to: { name: "Company.Settings" },
      },
      {
        text: "หนังสือรับรอง",
        disabled: true,
      },
    ],
    dialog: false,
    alert: false,
    expireDate: null,
  }),
  mounted() {
    this.alertToken();
  },
  watch: {
    listKey: {
      handler: function () {
        this.alertToken();
      },
    },
  },
  beforeDestroy() {
    this.$store.dispatch("keyByCompany/getCerListUnsubscribe");
  },
  methods: {
    query: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("keyByCompany/getList", { companyId });
      }
    },
    checkExpireDate: function (endDate) {
      let date = moment.unix(endDate.seconds);
      if (date.toDate()) {
        return date.toDate() > new Date();
      }
    },
    timeFormat: function (timestamp) {
      if (timestamp) {
        return moment(timestamp.toDate())
          .add(543, "years")
          .format("Do MMM YY, LTS");
      }
      return "-";
    },
    getNameIssuer: function (nameIssuer) {
      let name = "-";
      if (nameIssuer && nameIssuer.CN) {
        name = nameIssuer.CN;
      }
      if (nameIssuer && nameIssuer.O) {
        name = `${name} (${nameIssuer.O})`;
      }
      return name;
    },
    getNameSubject: function (nameSubject) {
      let name = "-";
      if (nameSubject && nameSubject.CN) {
        name = nameSubject.CN;
      }
      if (nameSubject && nameSubject["2.5.4.97"]) {
        name = `${name} (${nameSubject["2.5.4.97"]})`;
      }
      return name;
    },
    alertToken: function () {
      moment.locale("th");

      let isExpire = this.listKey.find((key) => {
        const expireDate = moment.unix(key.timeNotAfter.seconds);
        const daysDiff = expireDate.diff(new Date(), "days");
        return daysDiff >= 0 && daysDiff <= 30;
      });

      if (isExpire) {
        this.expireDate = moment
          .unix(isExpire.timeNotAfter.seconds)
          .add(543, "years")
          .format("Do MMM YYYY, LTS");
        this.alert = true;
      }
    },
  },
};
</script>

<style lang="scss">
.danger {
  min-width: 450px;
  height: 75px;
  background-color: #c9242b;
  position: absolute;
  border-radius: 0 0 15px 15px !important;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 16px;
  left: 258px;

  @media only screen and (max-width: 700px) {
    border-radius: 10px;
  }
}

.v-card > *:last-child:not(.v-btn):not(.v-chip) {
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 0;

  @media only screen and (max-width: 700px) {
    border-radius: 10px;
  }
}
</style>
